import React, { useState, useEffect } from 'react';
import '../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/CheckboxList.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../Components/BasicElements/BackModal';
import ConfirmModal from '../../Components/BasicElements/ConfirmModal';
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const InsertHoliday = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [hasChanges, setHasChanges] = useState(false);
	const [inputError, setInputError] = useState([]);
	const [showBackModal, setShowBackModal] = useState(false); // State for back confirmation modal
	const [showConfirmModal, setShowConfirmModal] = useState(false); // State for confirmation modal
	const [addData, setAddData] = useState([]);

	//#region save button Function Onlick
	function RegisterNewHoliday() {
		let functionName = "";
		try {
			functionName = props.page + RegisterNewHoliday.name;
			setLoading(true);
			setLoadingText("Registering New Holiday, PLease wait....")
			const data = {
				HOLIDAY_ID: addData.HOLIDAY_ID,
				HOLIDAY_NAME: addData.HOLIDAY_NAME.trim(),
				HOLIDAY_DATE: addData.HOLIDAY_DATE,
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.post("api/holiday/RegisterHoliday", data, { timeout: 1000000 })
				.then((response) => {
					if (response.data.DUPLICATE_LEAVE === true) {
						toast.error("User applied leave on " + common.c_Dis_DateTime(response.data.HOLIDAY_DATE).val_datetime.toLocaleDateString('en-GB'));
					}
					else if (response.data.DUPLICATE_HOLIDAY_DATE === true) {
						toast.error(response.data.HOLIDAY_NAME + " " + common.c_Dis_DateTime(response.data.HOLIDAY_DATE).val_datetime.toLocaleDateString('en-GB') + " already exist.");
					}
					else {
						toast.success("Holiday is successfully inserted.");
						props.onReload();
					}
				})
				.catch((err) => {
					toast.error("Failed to insert holiday. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
		} catch (err) {
			toast.error("Failed to insert holiday. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}

		setAddData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
	};

	//#region Event Handle
	const hideModal = () => {
		setAddData([]);
		setInputError([]);
		props.onHide();
	};

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		var flag = true;
		if (addData.HOLIDAY_NAME === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				HOLIDAY_NAME: (" Holiday Name could not be empty."),
			}));
		}
		if (!addData.HOLIDAY_DATE) {
      flag = false;
      setInputError((prevState) => ({
        ...prevState,
        HOLIDAY_DATE: (" Holiday Date could not be empty."),
      }));
    }
		if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			setShowConfirmModal(true);
		}
	};

	const handleConfirmModal = () => {
		RegisterNewHoliday();
		setShowConfirmModal(false); // Hide confirm modal
		hideModal();
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide confirm modal
	};

	return (
		<>
		<Modal show={props.showHide} onHide={hideModal} centered size="mg">
			<Modal.Header>
				<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
					<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Create</Modal.Title>
				</div>
			</Modal.Header>

			<Modal.Body>
				<Comp.Input
					id="HOLIDAY_NAME"
					label="Holiday Name*"
					name="Holiday Name"
					type="text"
					className="form-control"
					errorMessage={inputError.HOLIDAY_NAME}
					value={addData.HOLIDAY_NAME}
					onChange={inputRequiredHandler}
				/>

				<Comp.Input
					id="HOLIDAY_DATE"
					label="Holiday date*"
					name="Holiday date"
					type="date"
					className="form-control"
					errorMessage={inputError.HOLIDAY_DATE}
					value={addData.HOLIDAY_DATE}
					onChange={inputRequiredHandler}
				/>
			</Modal.Body>

			<Modal.Footer>
				<div className="onright-container">
					<Comp.Button
						id="btnCancel"
						type="cancel"
						onClick={handleBack}
					>
						<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
					</Comp.Button>
						
					<Comp.Button id="btnSave" onClick={handleConfirm}>
						<FontAwesomeIcon icon={faCheck} />&nbsp; Save
					</Comp.Button>
				</div>
			</Modal.Footer>
		</Modal>

		{/* Success Message Modal */}
		<BackModal
			show={showBackModal}
			onHide={handleConfirmBackCancel}
			onConfirm={handleConfirmBack}
			prop="Confirm Navigation"
		>
			Are you sure you want to go back? Your changes may be lost.
		</BackModal>

		<ConfirmModal
			show={showConfirmModal}
			onHide={handleConfirmModalClose}
			onConfirm={handleConfirmModal}
			prop="Confirm to save"
		>
			Are you sure you want to create new holiday?
		</ConfirmModal>

		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />
		</>
	);
};

export default InsertHoliday;